
import { borders } from "./foundations/borders"
import { breakpoints }  from "./foundations/breakpoints"
import { radii }  from "./foundations/radii"
import { shadows }  from "./foundations/shadows"
import { sizes }  from "./foundations/sizes"
import { space } from "./foundations/space"
import { transition }  from "./foundations/transition"
import { typography }  from "./foundations/typography"
import { zIndices }  from "./foundations/z-index"
import { blur }  from "./foundations/blur"
import { styles } from "./global/styles"
import { components } from "./components"
import { semanticTokens } from './global/semantic-tokens'
import { config } from './global/config'
import { colors } from "./foundations/colors"


export default {
  components,
  semanticTokens,
  styles,
  config,

  sizes,
  space,
  ...typography,
  zIndices,
  transition,
  radii,
  breakpoints,
  borders,
  blur,

  colors: {
    ...colors,
    readable: {
      normal: '#E6E8EA',
      primary: '#294AE0',
      masked: '#76808F',
      disabled: '#5E6673',
      placeholder: '#5E6673',
    },

    bg: {
      normal: '#1E2026',
      masked: '#14151A',
  
      tooltip: {
        normal: '#1E2026',
        accent: '#2B2F36',
        outer: '#0B0E11',
      },
  
      input: {
        normal: '#2B2F36',
      },
    },
  
    text: {
      normal: "#E6E8EA",
      primary: "#294AE0",
      masked: "#76808F",
      disabled: "#5E6673",
      placeholder: "#5E6673",
    },

    scene: {
      border: '#2E323A',
  
      primary: {
        normal: '#294AE0',
        active: '#3257FF',
      },
    
      secondary: {
        normal: '#2B2F36',
        active: '#3257FF',
      },
    
      success: {
        normal: '#02C076',
        active: '#2ED191',
      },
      
      danger: {
        normal: '#D9304E',
        active: '#FC6E75',
      },
    
      warning: {
        normal: '#F0B90B',
        active: '#F8D12F',
      },
    
      purple: {
        normal: '#9B00FB',
        active: '#B845FF',
      },
    },
  },

  shadows: {
    ...shadows,
    normal: '0px 2px 8px rgba(11, 14, 17, 1)',
    box: {
      normal: '0px 0px 16px rgba(11, 14, 17, 1)',
      increased: '0px 0px 16px rgba(11, 14, 17, 0.24)',
    },
  },
}